export enum CoachSmartSpaceChecklistSteps {
  FRANCHISEE_AGREEMENT = 1,
}
